import React from "react";
import { MESSAGE_CONFIG } from "../../../constents";
import * as TypesComponents from "./Types";
const MediaTypes = [
    MESSAGE_CONFIG.TYPES.MESSAGE_TYPE_IMAGE,
    MESSAGE_CONFIG.TYPES.MESSAGE_TYPE_IMAGE_OTHER,
    MESSAGE_CONFIG.TYPES.MESSAGE_TYPE_VIDEO,
    MESSAGE_CONFIG.TYPES.MESSAGE_TYPE_VIDEO_OTHER,
    MESSAGE_CONFIG.TYPES.MESSAGE_TYPE_DOC,
    MESSAGE_CONFIG.TYPES.MESSAGE_TYPE_VOICE,
    MESSAGE_CONFIG.TYPES.MESSAGE_TYPE_VOICE_OTHER,
];
const RichTextTypes = [
    MESSAGE_CONFIG.TYPES.MESSAGE_TYPE_RICH_TEXT,
    MESSAGE_CONFIG.TYPES.MESSAGE_TYPE_RICH_TEXT_OTHER
];
const ContentMapper = (type) => {
    switch (true) {
        case RichTextTypes.includes(type):
            return TypesComponents.RichText;
        case type === MESSAGE_CONFIG.TYPES.MESSAGE_TYPE_TEXT:
            return TypesComponents.Text;
        case MediaTypes.includes(type):
            return TypesComponents.Media;
        default:
            return TypesComponents.Text;
    }
};
const MessageContent = (props) => {
    const { message } = props;
    const Content = ContentMapper(message.type);
    return React.createElement(Content, { message: message });
};
export default React.memo(MessageContent);
